import { useQuery } from "@tanstack/react-query"
import { getCompaniesByRfqId } from "@/lib/api/company.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetCompaniesByRfqId(rfqId: string, enabled: boolean = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["companies-by-rfq", rfqId],
    queryFn: () => getCompaniesByRfqId(rfqId, accessToken!),
    enabled: !!accessToken && !!rfqId && enabled,
    staleTime:0,
  })
}
